import { ValidationType } from '../../../core/constants/validationType';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { soundService } from '../../../services/baseSoundService/soundService';
import { userInfoStore } from '../../../store/userInfoStore';
import { notificationStore } from '../../../store/notificationStore';
import { checkHashStore } from '../../../store/checkHashStore';
import { parseNumberByPrecision } from '../../../core/helpers/parseNumberByPrecision';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { towerBetStore } from '../towerStore/betStore';
import {
  MAP_TYPES,
  SIZES_BY_MAP_TYPES,
  TowerBetStatus,
  towerSoundsName,
} from '../towerCore/constants';
import { towerGameConnection } from '../towerConnection';
import { worker } from '../../../index';
import { TowerSoundsName } from '../towerCore/constants/sounds';
import { freeBetStore } from '../../../store/freeBetStore';

let autoSelectTimeOutId;
let resetTimeOutId;

class TowerGameService {
  onGetInitialStateResult({ lastSpinInfo, spinInfo, additionalInfo }) {
    this.handleResetStateInitial();
    if (lastSpinInfo) {
      checkHashStore.setLastRoundInfo({
        key: lastSpinInfo.key,
        salt: lastSpinInfo.salt,
        hash: lastSpinInfo.hash,
      });
      checkHashStore.setLastRoundResult({
        mapType: lastSpinInfo.mapType,
        steps: lastSpinInfo.steps,
        bombIndexes: lastSpinInfo.bombIndexes,
        id: lastSpinInfo.id,
      });
    }
    towerBetStore.setTowerOddsBySize(additionalInfo.odds);
    towerBetStore.setDecisionDuration(15);
    if (spinInfo) {
      const { spinData, winAmount, amount } = spinInfo;
      const { mapType, selectedIndexes, step, steps, second } = spinData;
      towerBetStore.setIsDoSpinStart(true);
      if (step) {
        towerBetStore.setIsAllowCashOut(true);
      }

      towerBetStore.setIsAllowSendResultReport(true);
      userInfoStore.setBetAmount(parseNumberByPrecision(1, +amount, userInfoStore.precision));
      towerBetStore.setTowerMatrixSizeHorizontal(SIZES_BY_MAP_TYPES[mapType].h);
      towerBetStore.setTowerMatrixSizeVertical(SIZES_BY_MAP_TYPES[mapType].v);
      towerBetStore.setSelectedIndexes(selectedIndexes);
      towerBetStore.setSelectedStep(step);
      towerBetStore.setSteps(steps);
      towerBetStore.setCashOutWin(winAmount);
      towerBetStore.setWinAmount(winAmount);
      this.sendWorker(second);
    }
  }

  doSpin() {
    const { towerMatrixSizeVertical, towerMatrixSizeHorizontal } = towerBetStore;
    if (!towerBetStore.isDoSpinStart) {
      soundService.play(TowerSoundsName.bet);
      const model = {
        spinData: {
          mapType: MAP_TYPES[`${towerMatrixSizeHorizontal}x${towerMatrixSizeVertical}`],
        },
      };
      mainGameConnection.doSpin(model);
      towerBetStore.setIsDoSpinStart(true);
    }
  }

  handleDoSpinResult({ responseCode, balance }) {
    if (responseCode === ValidationType.Success) {
      towerBetStore.setIsAllowSendResultReport(true);
      if (!freeBetStore.currentFreeBet) {
        userInfoStore.setUserBalance(balance);
      }
      towerBetStore.setCashOutWin(0);
      towerBetStore.setSelectedStep(0);
      towerBetStore.setIsAllowSendResultReport(true);
    } else {
      towerBetStore.setIsDoSpinStart(false);
      notificationStore.setNotification(responseCode);
    }
  }

  handleRandomSelectBox() {
    const index = Math.floor(Math.random() * towerBetStore.towerMatrixSizeHorizontal);
    if (towerBetStore.isAllowSendResultReport) {
      towerGameConnection.sendResultReport({ index }).then();
      towerBetStore.setIsAllowSendResultReport(false);
    }
  }

  handleSendReportStateResult(index) {
    if (towerBetStore.isAllowSendResultReport) {
      towerGameConnection.sendResultReport({ index }).then();
      towerBetStore.setIsAllowSendResultReport(false);
    }
  }

  handleReportStateResult({
    responseCode,
    winAmount,
    odd,
    newHash,
    hash,
    freebetInfo,
    key,
    salt,
    spinId,
    status,
    step,
    result,
  }) {
    towerBetStore.setIsAllowSendResultReport(true);
    if (responseCode === ValidationType.Success) {
      if (freebetInfo !== null) {
        freeBetStore.updateCurrentFreeBet(freebetInfo);
      }
      const { steps, mapType, bombIndexes } = result;
      towerBetStore.setRoundResult(true);
      towerBetStore.setCashOutWin(winAmount);
      towerBetStore.setSteps(steps);
      this.sendWorker();
      if (status === TowerBetStatus.lose) {
        towerBetStore.setRoundResult(false);
        towerBetStore.setIsAllowSendResultReport(false);
        if (userSettingsStore.isSoundOn) {
          soundService.play(towerSoundsName.bomb);
        }
        towerBetStore.setIsLose(true);
        checkHashStore.setLastRoundInfo({ salt, key, hash });
        checkHashStore.setNextRoundHash(newHash);
        checkHashStore.setLastRoundResult({
          steps,
          mapType,
          bombIndexes,
          id: spinId,
        });
        clearTimeout(resetTimeOutId);
        resetTimeOutId = setTimeout(() => {
          this.resetGameState();
        }, 1500);
      } else if (status === TowerBetStatus.onHold) {
        towerBetStore.setSelectedStep(step);
        this.sendWorker(towerBetStore.decisionDuration);
        towerBetStore.setIsAllowCashOut(true);
        if (userSettingsStore.isSoundOn) {
          soundService.play(TowerSoundsName.coin);
        }
      } else {
        this.handleWinState({
          winAmount,
          odd,
          salt,
          key,
          hash,
          newHash,
          spinId,
          additionalInfo: {
            steps,
            mapType,
            bombIndexes,
          },
        });
      }
    } else {
      notificationStore.setNotification(responseCode);
    }
  }

  sendCashOut() {
    if (towerBetStore.isAllowCashOut) {
      towerBetStore.setIsAllowCashOut(false);
      towerGameConnection.sendCashOut();
      clearTimeout(autoSelectTimeOutId);
    }
  }

  handleWinBet({ winAmount, odd }) {
    if (userSettingsStore.isSoundOn) {
      soundService.play(towerSoundsName.win);
    }
    towerBetStore.setWinAmount(winAmount);
    towerBetStore.setWinOdd(odd);
    towerBetStore.setRoundResult(false);
    clearTimeout(resetTimeOutId);
    resetTimeOutId = setTimeout(() => {
      this.resetGameState();
    }, 1500);
  }

  handleWinState({ winAmount, odd, salt, key, hash, newHash, spinId, additionalInfo }) {
    towerBetStore.setIsAllowSendResultReport(false);
    this.sendWorker();
    this.handleWinBet({ winAmount, odd });
    towerBetStore.setSelectedStep(null);
    checkHashStore.setLastRoundInfo({ salt, key, hash });
    checkHashStore.setNextRoundHash(newHash);
    checkHashStore.setLastRoundResult({
      steps: additionalInfo.steps,
      mapType: additionalInfo.mapType,
      bombIndexes: additionalInfo.bombIndexes,
      id: spinId,
    });
  }

  handleCashOutResult({
    winAmount,
    responseCode,
    odd,
    key,
    salt,
    hash,
    freebetInfo,
    newHash,
    spinId,
    additionalInfo,
  }) {
    if (responseCode === ValidationType.Success) {
      if (freebetInfo !== null) {
        freeBetStore.updateCurrentFreeBet(freebetInfo);
      }
      this.handleWinState({
        winAmount,
        odd,
        salt,
        key,
        hash,
        newHash,
        additionalInfo,
        spinId,
      });
    } else {
      notificationStore.setNotification(responseCode);
    }
  }

  handleChangeBombCountResult({ hash }) {
    checkHashStore.setNextRoundHash(hash);
  }

  resetGameState() {
    towerBetStore.resetStore();
    betHistoryStore.getLastBet();
    userInfoStore.getBalance();
  }

  countDown({ data }) {
    towerBetStore.setTime(data?.timerValue);
  }

  sendWorker(time) {
    if (time) {
      worker.addEventListener('message', this.countDown);
      worker.postMessage({
        timerValue: time,
        deductionValue: 1,
        intervalDelay: 900,
        precision: 0,
      });
    } else {
      worker.removeEventListener('message', this.countDown);
      towerBetStore.resetTime();
    }
  }

  handleResetStateInitial() {
    towerBetStore.resetStore();
    towerBetStore.setTowerMatrixSizeHorizontal(3);
    towerBetStore.setTowerMatrixSizeVertical(6);
  }
}

export const towerGameService = new TowerGameService();
